<template>
    <div>
        <incoming-modal ref="incoming" v-if="incomingCall" :call="incomingCall" :workers="workers" @hangup="hangup"></incoming-modal>
        <!--<incoming-modal ref="incoming" v-if="true" :call="true" :workers="workers" @hangup="hangup"></incoming-modal>-->
        <outcoming-modal ref="outcoming" :workers="workers" v-if="showOutcomingModal"
                         @outcoming-call="handleOutcomingCall"
                         @hangup="hangup"
                         @send-digits="handleSendDigits"
        ></outcoming-modal>
    </div>
</template>

<script>
    import { Device } from '@twilio/voice-sdk';
    export default {
        name: "Ivr",
        props: {
            workers: Array,
            workerStatus: String
        },
        data() {
            return {
                ready: true,
                error: null,
                incomingCall: null,
                connection: null
            }
        },
        computed:{
            device() {
                return this.$store.state.device;
            },
            showOutcomingModal() {
                return this.$store.state.showOutcoming;
            }
        },
        watch: {
            workerStatus: function (val){
                if(val === 'Offline'){
                    /*
                    if(Device.activeConnection()){
                        Device.activeConnection().ignore();
                    }
                     */
                    this.incomingCall = null;
                    this.device.disconnectAll();
                    this.device.destroy();
                    setTimeout(() => {
                        this.getToken(true);
                        this.$http.post('/ivr/worker_update');
                    }, 3000);
                }
            },
            incomingCall: function (val) {
                if(!val && !this.showOutcomingModal && this.workerStatus === 'Busy'){
                    setTimeout(() => {
                        this.$http.post('/ivr/worker_update');
                    }, 3000);
                }
            },
            showOutcomingModal: function (val) {
                if(!val && !this.incomingCall && this.workerStatus === 'Busy'){
                    setTimeout(() => {
                        this.$http.post('/ivr/worker_update');
                    }, 3000);
                }
            }
        },
        mounted() {
            this.prepareComponent()
        },
        destroyed() {
            this.device.destroy();
        },
        methods: {
            prepareComponent(){
                this.getToken(true);
            },
            getToken(withListeners){
                this.$http.post('/ivr/token').then(response => {
                    console.log('set token');
                    const token = response.data;
                    const deviceOb = new Device(token, {
                        sounds: {
                            incoming: '/sounds/alarm.mp3',
                        }
                    });
                    console.log(deviceOb);
                    this.$store.dispatch('setDevice', deviceOb);
                    console.log('state');
                    console.log(this.$store.state.device);
                    if(withListeners){
                        console.log('generado listener');
                        deviceOb.on('ready', (device) =>{
                            console.log('ready on');
                            this.ready = device;
                            // this.dial('+525544322917');
                        });

                        deviceOb.on('disconnect', (conn) => {
                            console.log('Call ended.');
                            if(this.incomingCall){
                                 this.incomingCall = null;
                            }
                            if(this.showOutcomingModal){
                                // this.$store.commit('showOutcoming', false);
                            }
                        });

                        deviceOb.on('cancel', (conn) => {
                            console.log('Call canceled.');
                            this.incomingCall = null;
                            if(this.showOutcomingModal){
                                this.$store.commit('showOutcoming', false);
                            }
                        });

                        deviceOb.on('error', (error) => {
                            this.$notify.danger(this.filterError(error));
                            console.log('Device Error: ' + error.code);
                            console.log('Device Error: ' + error.message);
                            if(error){
                                this.getToken(false);
                            }
                        });

                        deviceOb.on('incoming', (call) => {
                            console.log(call);
                            this.incomingCall = call;
                        });

                        deviceOb.on('registered', () => {
                            console.log('The device is ready to receive incoming calls.')
                        });

                        deviceOb.register();
                    }
                });
            },
            handleOutcomingCall(e){
                const params = {
                    params: e
                };
                console.log(params);
                this.connection = this.device.connect(params);
            },
            hangup(){
                this.device.disconnectAll();
                if(this.incomingCall){
                    this.incomingCall = null;
                }
            },
            dial(to = null){
                let params = {};
                if(to){
                    params = Object.assign({}, params, {To:to}) ;
                }
                console.log('Calling ' + to + '...');
                this.device.connect(params);
            },
            setValidPhoneNumber(isValid){
                if(!isValid){
                    this.$refs.outcoming.error = 'Número telefónico invalido';
                }
            },
            handleSendDigits(e){
                if(this.connection){
                    // console.log('enviando: ' + e.digits);
                    this.connection.sendDigits(e.digits);
                }
            },
            filterError(error){
                let result = error.message;
                switch (error.code) {
                    case 31201:
                        result = 'Se produjo un error al acceder al micrófono. Verifique que esta conectado correctamente';
                        break;
                }
                return result;
            }
        }
    }
</script>

<style scoped>

</style>
